'use client';

// core (MUI)
import {
  deDE as deDECore,
  esES as esESCore,
} from '@mui/material/locale';
// date pickers (MUI)
import {
  deDE as deDEDate,
  enUS as enUSDate,
  esES as esESDate,
} from '@mui/x-date-pickers/locales';
// data grid (MUI)
import {
  deDE as deDEDataGrid,
  enUS as enUSDataGrid,
  esES as esESDataGrid,
} from '@mui/x-data-grid/locales';

// ----------------------------------------------------------------------

export const allLangs = [
  {
    value: 'en',
    label: 'English',
    languageName: 'English',
    countryCode: 'GB',
    adapterLocale: 'en-gb',
    numberFormat: { code: 'en-GB', currency: 'GBP' },
    systemValue: {
      components: { ...enUSDate.components, ...enUSDataGrid.components },
    },
  },
  {
    value: 'de',
    label: 'Deutsch',
    languageName: 'German',
    countryCode: 'DE',
    adapterLocale: 'de',
    numberFormat: { code: 'de-DE', currency: 'EUR' },
    systemValue: {
      components: { ...deDECore.components, ...deDEDate.components, ...deDEDataGrid.components },
    },
  },
  {
    value: 'es',
    label: 'Español',
    languageName: 'Spanish',
    countryCode: 'ES',
    adapterLocale: 'es',
    numberFormat: { code: 'es-ES', currency: 'EUR' },
    systemValue: {
      components: { ...esESCore.components, ...esESDate.components, ...esESDataGrid.components },
    },
  },
];

/**
 * Country code:
 * https://flagcdn.com/en/codes.json
 *
 * Number format code:
 * https://gist.github.com/raushankrjha/d1c7e35cf87e69aa8b4208a8171a8416
 */
